const CaseStudy = () => {
	
};

export default CaseStudy;
